import React, { createContext, useContext, useState, useEffect } from 'react';
import { useGetMeLazyQuery } from 'generated/schemaTypes';
import { useAuthContext } from './AuthProvider';

type IdentityContextType = {
  user?: {
    userID: string;
    username: string;
    avatar: string;
  };
  loading: boolean;
};

const IdentityContext = createContext<IdentityContextType>({ loading: true });

const IdentityProvider: React.FC = ({ children }) => {
  const { authUser } = useAuthContext();

  const [identity, setIdentity] = useState<IdentityContextType>({
    loading: true
  });
  const [getMe, { loading, data }] = useGetMeLazyQuery();

  useEffect(() => {
    getMe();
  }, [authUser, getMe]);

  useEffect(() => {
    setIdentity({
      user: data?.me?.id
        ? {
            userID: data?.me?.id,
            username: data?.me?.username,
            avatar: data?.me?.avatar
          }
        : undefined,
      loading
    });
  }, [data, loading]);

  return (
    <IdentityContext.Provider value={identity}>
      {children}
    </IdentityContext.Provider>
  );
};

const useGetIdentity = () => useContext(IdentityContext);

export { IdentityContext, useGetIdentity };
export default IdentityProvider;
